import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { auth } from "../services/api";
import { FcGoogle } from "react-icons/fc";
import TwoFactorStep from "./TwoFactorStep"; // v3.4.510 — الخطوة الثانية بعد Google
// v3.3.589 — read from package.json so the version stays in sync automatically
import pkg from "../../package.json";

export default function LoginPage() {
  const { user, loading, mfa } = useAuth();
  const [params] = useSearchParams();
  const error = params.get("error");

  if (loading) return <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center"}}>جاري التحميل...</div>;
  if (user) return <Navigate to="/" />;
  // v3.4.510 — دخول Google نجح والخطوة الثانية معلّقة: شاشة الرمز (تطبيق المصادقة / واتساب) أو ربط التطبيق لأول مرة
  if (mfa) return <div className="login-page" dir="rtl"><div className="login-card" style={{ maxWidth: 440 }}><TwoFactorStep mfa={mfa} /><p style={{fontSize:11,color:"#999",marginTop:16,marginBottom:0}}>v{pkg.version}</p></div></div>;

  return (
    <div className="login-page" dir="rtl">
      <div className="login-card">
        <h1>نظام إدارة الحجوزات</h1>
        <p>Reservation Management System</p>

        {error === "not_invited" && (
          <div style={{background:"#fee2e2",color:"#991b1b",padding:"10px 14px",borderRadius:8,margin:"16px 0",fontSize:13,fontWeight:500}}>
            حسابك غير مسجل في النظام. يرجى التواصل مع المسؤول لإضافتك.
          </div>
        )}
        {error === "server_error" && (
          <div style={{background:"#fee2e2",color:"#991b1b",padding:"10px 14px",borderRadius:8,margin:"16px 0",fontSize:13,fontWeight:500}}>
            حدث خطأ في الخادم أثناء تسجيل الدخول. يرجى المحاولة مرة أخرى.
          </div>
        )}
        {error === "login_failed" && (
          <div style={{background:"#fee2e2",color:"#991b1b",padding:"10px 14px",borderRadius:8,margin:"16px 0",fontSize:13,fontWeight:500}}>
            فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.
          </div>
        )}
        {/* v3.4.509 — أسباب انتهاء الجلسة (سياسة الجلسات) */}
        {["idle_timeout", "session_expired", "policy_update", "session_ended", "replaced_by_new_login", "mfa_timeout"].includes(error) && (
          <div style={{background:"#fffbeb",color:"#92400e",padding:"10px 14px",borderRadius:8,margin:"16px 0",fontSize:13,fontWeight:500,lineHeight:1.8}}>
            {error === "idle_timeout" ? "انتهت الجلسة لعدم النشاط لأكثر من 30 دقيقة. سجّل الدخول من جديد."
              : error === "session_expired" ? "انتهت مدة الجلسة (12 ساعة). سجّل الدخول من جديد."
              : error === "policy_update" ? "تم تحديث إعدادات الأمان. سجّل الدخول من جديد."
              : error === "mfa_timeout" ? "انتهت مهلة إدخال رمز التحقق. سجّل الدخول من جديد."
              : "انتهت جلستك — قد يكون تم الدخول بحسابك من جهاز أو متصفح آخر. سجّل الدخول من جديد."}
          </div>
        )}
        {error === "deactivated" && (
          <div style={{background:"#fee2e2",color:"#991b1b",padding:"10px 14px",borderRadius:8,margin:"16px 0",fontSize:13,fontWeight:500}}>
            حسابك معطل. يرجى التواصل مع المسؤول.
          </div>
        )}

        <a href={auth.loginUrl} className="google-btn">
          <FcGoogle size={22} />
          <span>تسجيل الدخول بحساب Google</span>
        </a>
        <p className="note">فقط المستخدمين المضافين مسبقاً يمكنهم الدخول</p>
        <p style={{fontSize:11,color:"#999",marginTop:16}}>v{pkg.version}</p>
      </div>
    </div>
  );
}
